import React, { useEffect, useState, useRef } from 'react';
import Layout from '../../components/layout/Layout';
import { getData, deleteData, postData, putData } from '../../services/apiService';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
    IconButton, Button, TextField, Select, MenuItem, Pagination, InputAdornment,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Progress from '../../hooks/useProgressBar';
import useDebounce from '../../hooks/useDebounce';

const AssignCourseInstitute = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [couserData, setCourseData] = useState([]);
    const [instituteData, setInstituteData] = useState([]);
    const isFetched = useRef(false);
    const [showAssignCourseModal, assignCourseShowModal] = useState(false);
    const [updateAssignCourseModalShow, updateAssignCourseModal] = useState(false);
    const [formData, setFormData] = useState({ course: "", studentOrInstitut: "", status: "" });
    const [selectedAssignCourse, setSelectedAssignCourse] = useState(null);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 500);
    const [totalPages, setTotalPages] = useState(1);

    // onload
    useEffect(() => {
        if (!isFetched.current) {
            fetchData();
            getCourseData();
            getInstituteData();
        }
    }, [page, rowsPerPage, debouncedSearchQuery]);

    // Fetch all Lession from the API
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData(`/get-course-to-institute?page=${page}&limit=${rowsPerPage}&search=${debouncedSearchQuery}`);
            if (response) {
                setData(response.data);
                setTotalPages(response.totalPages);
            }
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch data', error);
            setLoading(false);
        }
    };

    const getCourseData = async () => {
        try {
            const response = await getData("get-courses-for-dropdown");
            if (response) {
                setCourseData(response);
            }

        } catch (error) {
            console.error('Feilde to fetch data', error)
        }
    }

    const getInstituteData = async () => {
        try {
            const response = await getData("get-colleges-for-dropdown");

            if (response) {
                setInstituteData(response);
            }

        } catch (error) {
            console.error('Failed to fetch data', error)
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setPage(1); // Reset to first page on new search
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(event.target.value);
        setPage(1);
    };

    // Assign Course
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const AssignCourse = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await postData('/assign-course-to-institute', formData);
            setFormData({ course: "", studentOrInstitut: "", status: "" });
            assignCourseShowModal(false);
            fetchData();
            setLoading(false);
        } catch (error) {
            console.error('Failed to post data', error);
            setLoading(false);
        }
    };

    // Edit Assign course
    const editAssignCourse = (id) => {
        const lessionData = data.find(lession => lession._id === id);
        setSelectedAssignCourse(lessionData);
        updateAssignCourseModal(true);
    };

    // Update Assign Courses 
    const updateAssignCourses = async () => {
        if (!selectedAssignCourse) return;

        const updatedData = {
            course: selectedAssignCourse?.course?._id || selectedAssignCourse.course,
            studentOrInstitut: selectedAssignCourse?.studentOrInstitut?._id || selectedAssignCourse.studentOrInstitut,
            status: selectedAssignCourse.status,
        };

        try {
            await putData(`/update-assign-course/${selectedAssignCourse._id}`, updatedData);
            fetchData();
            updateAssignCourseModal(false);
        } catch (error) {
            console.error('Failed to update lesson', error);
        }
    };

    // Delete Assign Course!
    const deleteAssignCourse = async (id) => {
        try {
            await deleteData(`/delete-assign-course/${id}`);
            await fetchData();
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Layout>
            {loading ? <Progress /> :
                <Box className="p-6 bg-gray-100 min-h-screen">
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 3 }}>Course Assign To Institute</Typography>
                    {/* Header: Add Button (left) and Search (right) */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2, }} >
                        <Button variant="contained" sx={{
                            borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                            '&:hover': { backgroundColor: '#3A3897', },
                        }} onClick={() => assignCourseShowModal(true)} > Assign Course </Button>
                        <TextField placeholder="Search Lession" value={searchQuery} onChange={handleSearchChange} variant="outlined" size="medium"
                            sx={{ width: 350, bgcolor: '#e9ecef', borderRadius: 2, '& .MuiOutlinedInput-root': { borderRadius: 2, }, }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#757575' }} />
                                    </InputAdornment>
                                ),
                                sx: { bgcolor: '#e9ecef', borderRadius: 2 },
                            }}
                        />
                    </Box>
                    {/* <TableContainer component={Paper} elevation={0} sx={{ mb: 2, borderRadius: 2, boxShadow: 2, overflow: 'hidden', }} > */}
                    <TableContainer component={Paper}
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            overflowX: "auto",
                            overflowY: "hidden",
                            "&::-webkit-scrollbar": {
                                height: "8px"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#888",
                                borderRadius: "4px"
                            }
                        }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#4B49AC' }}>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopLeftRadius: 8 }}> ID </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> College Name </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Course </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Code </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Status </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopRightRadius: 8 }}> Action </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((item, index) => (
                                    <TableRow key={item._id}>
                                        <TableCell align="center">
                                            <Typography variant="body1">{(page - 1) * rowsPerPage + index + 1}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.studentOrInstitut.collegeName}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.course.courseName}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.course.code}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.status}</Typography>
                                        </TableCell>

                                        <TableCell align="center">
                                            <IconButton color="primary" onClick={() => editAssignCourse(item._id)}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton color="error" onClick={() => deleteAssignCourse(item._id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* Pagination */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Pagination count={totalPages} page={page} onChange={handlePageChange} shape="rounded"
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    '&.Mui-selected': {
                                        bgcolor: '#4B49AC',
                                        color: 'white',
                                    },
                                },
                            }}
                        />
                        <Select value={rowsPerPage} onChange={handleRowsPerPageChange} size="small"
                            sx={{ ml: 2, height: 35, bgcolor: '#f7f7f7', border: '1px solid #e2e2e2', '& .MuiSelect-select': { py: 0.75 }, }}
                            IconComponent={KeyboardArrowDownIcon} >
                            <MenuItem value={10}>10 / page</MenuItem>
                            <MenuItem value={20}>20 / page</MenuItem>
                            <MenuItem value={50}>50 / page</MenuItem>
                        </Select>
                    </Box>

                    {/* Lession Add model */}
                    <Modal show={showAssignCourseModal} onHide={() => assignCourseShowModal(false)} style={{ zIndex: 9999 }} backdrop="static" keyboard={false} >
                        <Modal.Header closeButton>
                            <Modal.Title>Course Assignment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={AssignCourse}>
                                <div className="mb-3">
                                    <label className="col-form-label">Course: <span style={{ color: 'red' }}>*</span></label>
                                    <select className="form-select" name="course" value={formData.course} onChange={handleInputChange} >
                                        <option value="">Select Course</option>
                                        {couserData.map((course) => (
                                            <option key={course._id} value={course._id}>{course.courseName}</option>
                                        ))}
                                    </select>
                                    <label className="col-form-label">Institution: <span style={{ color: 'red' }}>*</span></label>
                                    <select className="form-select" name="studentOrInstitut" value={formData.studentOrInstitut} onChange={handleInputChange} >
                                        <option value="">Select Institut</option>
                                        {instituteData.map((institute) => (
                                            <option key={institute._id} value={institute._id}>{institute.collegeName}</option>
                                        ))}
                                    </select>
                                    <label className="col-form-label">Status: <span style={{ color: 'red' }}>*</span></label>
                                    <select className="form-select" name="status" value={formData.status} onChange={handleInputChange} >
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="InActive">InActive</option>
                                    </select>
                                </div>
                                <Modal.Footer>
                                    <Button variant="contained" type="submit" color="primary" sx={{ bgcolor: '#3A3897', '&:hover': { bgcolor: '#2A2878', } }}>Save</Button>
                                </Modal.Footer>
                            </form>
                        </Modal.Body>
                    </Modal>

                    {/* Lession update model */}
                    <Modal show={updateAssignCourseModalShow} onHide={() => { updateAssignCourseModal(false); }} style={{ zIndex: 9999 }} backdrop="static" keyboard={false} >
                        <Modal.Header closeButton>
                            <Modal.Title>Course Assignment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form>
                                <div className="mb-3">
                                    <label className="col-form-label">Course:</label>
                                    <select className="form-select" name="course" value={selectedAssignCourse?.course?._id} onChange={(e) => setSelectedAssignCourse({ ...selectedAssignCourse, course: e.target.value })} >
                                        <option value="">Select Course</option>
                                        {couserData.map((course) => (
                                            <option key={course._id} value={course._id}>{course.courseName}</option>
                                        ))}
                                    </select>
                                    <label className="col-form-label">Institution:</label>
                                    <select className="form-select" name="studentOrInstitut" value={selectedAssignCourse?.studentOrInstitut?._id} onChange={(e) => setSelectedAssignCourse({ ...selectedAssignCourse, studentOrInstitut: e.target.value })} >
                                        <option value="">Select Course</option>
                                        {instituteData.map((institute) => (
                                            <option key={institute._id} value={institute._id}>{institute.collegeName}</option>
                                        ))}
                                    </select>
                                    <label className="col-form-label">Status: </label>
                                    <select className="form-select" name="status" value={selectedAssignCourse?.status} onChange={(e) => {
                                        setSelectedAssignCourse({ ...selectedAssignCourse, status: e.target.value });
                                    }} >
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="InActive">InActive</option>
                                    </select>
                                </div>
                                <Modal.Footer>
                                    <Button variant="contained" onClick={updateAssignCourses} color="primary" sx={{ bgcolor: '#3A3897', '&:hover': { bgcolor: '#2A2878', } }}>Save changes</Button>
                                </Modal.Footer>
                            </form>
                        </Modal.Body>
                    </Modal>
                </Box>
            }
        </Layout>
    );
};

export default AssignCourseInstitute;